import {Component, Input, ViewChild} from "@angular/core";
import {FeedbackService} from "./feedback.service";
import {FeedbackConfiguration} from "./feedback-configuration.model";
import {FeedbackModel} from "./feedback.model";
import {Modal} from "@herbis/ngx-modal";


export class FeedbackModalComponent {

  
  configuration: FeedbackConfiguration;

  
  private modal: Modal;

  constructor(private feedback: FeedbackService) {
    feedback.modalComponent = this;
  }

  /**
   * Cancel the feedback.
   */
  public cancel(): void {
    /* Callback on cancel.*/
    if (this.configuration.onCancel) {
      this.configuration.onCancel();
    }

    this.closeModal();
  }

  /**
   * Close this modal.
   */
  public closeModal(): void {
    this.modal.close();
    this.feedback.showSendFeedbackButton();
  }

  /**
   * Open feedback modal.
   */
  public openModal(): void {
    this.modal.open();
  }

  /**
   * Submit the form.
   * @param form the form.
   */
  public submit(form: HTMLFormElement): void {
    let feedbackSubmission = new FeedbackModel();
    feedbackSubmission.form = form;
    feedbackSubmission.screenshots = this.feedback.getScreenshots();

    /* Callback on submit validation */
    if (this.configuration.onSubmitValidation) {
      if (!this.configuration.onSubmitValidation(feedbackSubmission)) {
        return; // Do not proceed if validation unsuccessful.
      }
    }

    /* Callback on submit. */
    if (this.configuration.onSubmit) {
      this.configuration.onSubmit(feedbackSubmission);
      this.closeModal();
    } else {
      console.warn("No onSubmit callback function configured. It probably should.");
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: "ngx-bootstrap-feedback-modal",
  template: `<modal title="{{configuration.feedbackModalTitle ? configuration.feedbackModalTitle : 'Send Feedback'}}"
        modalClass="{{configuration.feedbackModalClass ? configuration.feedbackModalClass : 'modal-md'}}"
        [hideCloseButton]="true"
        [closeOnEscape]="false"
        [closeOnOutsideClick]="false">
  <modal-header></modal-header>
  <modal-content>
    <form novalidate #userFeedbackForm>
      <ng-content></ng-content>
    </form>
  </modal-content>
  <modal-footer>
    <button [attr.class]="configuration.cancelFeedbackButtonClass ? configuration.cancelFeedbackButtonClass : 'btn btn-default'" data-dismiss="modal" type="button" (click)="cancel()">
      {{configuration.cancelFeedbackButtonText ? configuration.cancelFeedbackButtonText : "Cancel"}}
    </button>
    <button [attr.class]="configuration.submitFeedbackButtonClass ? configuration.submitFeedbackButtonClass : 'btn btn-primary'" type="button" (click)="submit(userFeedbackForm)">
      {{configuration.submitFeedbackButtonText ? configuration.submitFeedbackButtonText : "Submit"}}
    </button>
  </modal-footer>
</modal>
`
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: FeedbackService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'configuration': [{ type: Input },],
'modal': [{ type: ViewChild, args: [Modal, ] },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
